import messages from './crearusuaris-modal-translations';
import * as $ from 'jquery';
import { CrearUsuarisService } from './services/crearUsuarisService';

export default {
    name: 'instamapsCrearUsuarisModal',
    i18n: {
        messages,
    },
    data(){
        return {
            form: {
                numAlumnes: "",
            }
        };
    },
    props: {
        delay: { type: Number },
        isError: { type: Boolean },
        isLoaded: { type: Boolean },
        mapa: { type: Object },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#crearusuaris-modal-body').attr("style","display:block;");
                $('#crearusuaris-modal-msg').attr("style","display:none;");
                $('#crearusuaris-modal').addClass('animate-flex-modal');
                $('#crearusuaris-modal-body #numAlumnes').val("");
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#crearusuaris-modal').removeClass('animate-flex-modal');
            this.$emit('loaded');
        },
        crearUsersMapa: function(){    
            $('#crearusuaris-modal-body').attr("style","display:none;");
            $('#crearusuaris-modal-msg').attr("style","display:block;");        
            CrearUsuarisService.crearUsersMapa(this.mapa.businessId, this.form.numAlumnes, this.mapa.nomAplicacio,"true").then((response) => {
                if (response.status==="OK") {
                    window.dataLayer.push({
                        'event': 'crearUsersMapa',
                        'businessid': this.mapa.businessId,
                        'numUsuaris': this.form.numAlumnes 
                    });
                    this.$emit('derivatsMap', {businessId: this.mapa.businessId});
                    this.dismiss();
                }else{
                    this.dismiss();
                    this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
                }
            }).catch(() => {
                this.dismiss();
                this.$emit('error', {title: this.$t('title'), message: this.$t('messageError')});
            });
        }            
    },
    watch: {
        'isLoaded': function(val){
            if(val){
                this.show();
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/crearusuaris-modal/crearusuaris-modal.js